import React, { Component } from 'react'
import './progress-bar.css';
import { COLOUR_NAME_TO_COLOUR_HEX } from '../../../../../../../helpers/Colours';
import { WORKING_ON_NODE_DATA } from '../VisualisedNode';
// import { v } from '../../../koko-framework/shorthand';
// import { TWITCH_FEATURE_CONTROLLER } from '../../../controller/TwitchFeatureController';
// import { GetDiagonalStripes, GetSvgAngledRect, GetSvgRect, GetVerticalStripes } from './progress-bar';

const GetSvgRect = (width = 800, height = 30, strokeWidth = 1, strokeColor = '#FFFFFF', fillColor = 'none', cornerRadius = 5, maskId = '', maskOffsetY = 0) => {
    // console.log("getsvgrect");
    // console.log("maskId = ",maskId);
    // console.log("width = ",width);
    if (!isNaN(width) && !isNaN(height) && !isNaN(strokeWidth) && !isNaN(cornerRadius)) {
        return (
            <svg width={width + strokeWidth * 2} height={height + strokeWidth * 2} style={{ marginLeft: -strokeWidth, marginTop: -strokeWidth }}>
                {maskId !== '' &&
                    <clipPath id={maskId}>
                        <rect x={strokeWidth} y={strokeWidth + maskOffsetY} rx={cornerRadius} ry={cornerRadius} width={width} height={height} style={{ fill: fillColor, stroke: strokeColor, strokeWidth: strokeWidth, opacity: 1 }} />
                    </clipPath>
                }
                {maskId === '' &&
                    <rect x={strokeWidth} y={strokeWidth} rx={cornerRadius} ry={cornerRadius} width={width} height={height} style={{ fill: fillColor, stroke: strokeColor, strokeWidth: strokeWidth, opacity: 1 }} />
                }
            </svg>
        );
    } else {
        return null;
    }
}

const GetSvgAngledRect = (width = 800, height = 30, strokeWidth = 1, strokeColor = '#FFFFFF', fillColor = 'none', skew = 35, maskId = '') => {
    // console.log("getsvgangledrect");
    // console.log("maskId = ",maskId);
    // console.log("width = ",width);
    if (!isNaN(width) && !isNaN(height) && !isNaN(strokeWidth) && !isNaN(skew)) {
        return (
            <svg width={width + strokeWidth * 2 + skew} height={height + strokeWidth * 2} style={{ marginLeft: -(strokeWidth + skew / 2), marginTop: -strokeWidth }}>
                {maskId !== '' &&
                    <clipPath id={maskId}>
                        <polygon points={`${skew + strokeWidth},${strokeWidth} ${width + strokeWidth + skew},${strokeWidth} ${width + strokeWidth},${height + strokeWidth} ${strokeWidth},${height + strokeWidth}`} style={{ fill: fillColor, stroke: strokeColor, strokeWidth: strokeWidth, opacity: 1 }} />
                    </clipPath>
                }
                {maskId === '' &&
                    <polygon points={`${skew + strokeWidth},${strokeWidth} ${width + strokeWidth + skew},${strokeWidth} ${width + strokeWidth},${height + strokeWidth} ${strokeWidth},${height + strokeWidth}`} style={{ fill: fillColor, stroke: strokeColor, strokeWidth: strokeWidth, opacity: 1 }} />
                }
            </svg>
        )
    } else {
        return null;
    }
}

const GetDiagonalStripes = (color1 = '#FF0000', color2 = '#FFFF00', stripeWidth = 10) => {
    return (
        `
            repeating-linear-gradient(
                -45deg, 
                ${color1}, 
                ${color1} ${stripeWidth}px,
                ${color2} ${stripeWidth}px,
                ${color2} ${stripeWidth * 2}px
            )
        `
    )
}

const GetVerticalStripes = (color1 = '#FF0000', color2 = '#FFFF00', stripeWidth = 10) => {
    return (
        `
            repeating-linear-gradient(
                -90deg, 
                ${color1}, 
                ${color1} ${stripeWidth}px,
                ${color2} ${stripeWidth}px,
                ${color2} ${stripeWidth * 2}px
            )
        `
    )
}

const CustomSettings = 
    {
        inlineprogressbar:
        {
            "shapeAndPosition": {
                "shape": [
                    {
                        "shape": "rounded",

                        "roundness": 30,
                        "skew": 35,
                        "length": 40,
                        "thickness": 20
                    }
                ],
                "position": [
                    {
                        "position": "bottom",
                        "offsetX": 0,
                        "offsetY": 0
                    }
                ]
            },
            "appearance": {
                "outline": [
                    {
                        "colour": "#FF3333",
                        "thickness": 0
                    }
                ],
                "background": [
                    {
                        "fillType": "solid",
                        "stripeDirection": "diagonal",
                        "stripeColour1": "#333333",
                        "stripeColour2": "#666666",
                        "animateStripes": true,

                        "reverseStripeAnim": false,

                        "solidColour": "#666666",
                        "tileImage": true,
                        "filename": {
                            "filename": "barTile.png",
                            "isDefault": true,
                            "srcUrl": "./img/barTile.png",
                            "originalFile": "barTile.png",
                            "type": "image"
                        },
                        "animateImage": true,

                        "reverseImageAnim": false,

                        "isDefault": true
                    }
                ],
                "fill": [
                    {
                        "fillType": "striped",
                        "stripeDirection": "diagonal",
                        "stripeColour1": "#DD0000",
                        "stripeColour2": "#990000",
                        "animateStripes": true,

                        "reverseStripeAnim": false,

                        "solidColour": "#00AAAA",
                        "tileImage": false,
                        "filename": {
                            "filename": "barTile.png",
                            "isDefault": true,
                            "srcUrl": "./img/barTest.png",
                            "originalFile": "barTile.png",
                            "type": "image"
                        },
                        "animateImage": false,

                        "reverseImageAnim": true,
                        "imageEdgeBuffer": 350,

                        "isDefault": true
                    }
                ]
            }
        }
    }

export const convertCustomisationDataToBarSettings = (customisationData, settingsObject = null) => {
    if (customisationData) {
        const resultingSettings = settingsObject || JSON.parse(JSON.stringify(CustomSettings['inlineprogressbar']));
        resultingSettings.shapeAndPosition.shape[0].shape = customisationData?.shape ?? settingsObject?.shapeAndPosition.shape[0].shape ?? 'square';
        resultingSettings.shapeAndPosition.shape[0].roundness = customisationData?.roundness ?? settingsObject?.shapeAndPosition.shape[0].roundness ?? 0;

        resultingSettings.appearance.outline[0].colour = customisationData?.outlineColour ?? settingsObject?.appearance.outline[0].colour ?? '#FFFFFF';
        resultingSettings.appearance.outline[0].thickness = customisationData?.outlineThickness ?? settingsObject?.appearance.outline[0].thickness ?? 2;

        resultingSettings.appearance.fill[0].fillType = customisationData?.barFillType ?? settingsObject?.appearance.fill[0].fillType ?? 'solid';
        resultingSettings.appearance.fill[0].stripeDirection = customisationData?.barStripeDirection ?? settingsObject?.appearance.fill[0].stripeDirection ?? 'diagonal';
        resultingSettings.appearance.fill[0].stripeColour1 = customisationData?.barStripeColour1 ?? settingsObject?.appearance.fill[0].stripeColour1 ?? '#FFFFFF';
        resultingSettings.appearance.fill[0].stripeColour2 = customisationData?.barStripeColour2 ?? settingsObject?.appearance.fill[0].stripeColour2 ?? '#000000';
        resultingSettings.appearance.fill[0].animateStripes = customisationData?.barAnimateStripes ?? settingsObject?.appearance.fill[0].animateStripes ?? false;
        resultingSettings.appearance.fill[0].reverseStripeAnim = customisationData?.barReverseStripeAnim ?? settingsObject?.appearance.fill[0].reverseStripeAnim ?? false;
        resultingSettings.appearance.fill[0].solidColour = customisationData?.barSolidColour ?? settingsObject?.appearance.fill[0].solidColour ?? '#FFFFFF';
        resultingSettings.appearance.fill[0].tileImage = customisationData?.barTileImage ?? settingsObject?.appearance.fill[0].tileImage ?? false;
        resultingSettings.appearance.fill[0].filename = customisationData?.barFilename ?? settingsObject?.appearance.fill[0].filename ?? {
            "filename": "barTile.png",
            "isDefault": true,
            "srcUrl": "./img/barTest.png",
            "originalFile": "barTile.png",
                "type": "image"
            };
        resultingSettings.appearance.fill[0].animateImage = customisationData?.barAnimateImage ?? settingsObject?.appearance.fill[0].animateImage ?? false;
        resultingSettings.appearance.fill[0].reverseImageAnim = customisationData?.barReverseImageAnim ?? settingsObject?.appearance.fill[0].reverseImageAnim ?? false;
        resultingSettings.appearance.fill[0].imageEdgeBuffer = customisationData?.barImageEdgeBuffer ?? settingsObject?.appearance.fill[0].imageEdgeBuffer ?? 0;

        resultingSettings.appearance.background[0].fillType = customisationData?.bgFillType ?? settingsObject?.appearance.background[0].fillType ?? 'solid';
        resultingSettings.appearance.background[0].stripeDirection = customisationData?.bgStripeDirection ?? settingsObject?.appearance.background[0].stripeDirection ?? 'diagonal';
        resultingSettings.appearance.background[0].stripeColour1 = customisationData?.bgStripeColour1 ?? settingsObject?.appearance.background[0].stripeColour1 ?? '#FFFFFF';
        resultingSettings.appearance.background[0].stripeColour2 = customisationData?.bgStripeColour2 ?? settingsObject?.appearance.background[0].stripeColour2 ?? '#000000';
        resultingSettings.appearance.background[0].animateStripes = customisationData?.bgAnimateStripes ?? settingsObject?.appearance.background[0].animateStripes ?? false;
        resultingSettings.appearance.background[0].reverseStripeAnim = customisationData?.bgReverseStripeAnim ?? settingsObject?.appearance.background[0].reverseStripeAnim ?? false;
        resultingSettings.appearance.background[0].solidColour = customisationData?.bgSolidColour ?? settingsObject?.appearance.background[0].solidColour ?? '#FFFFFF';
        resultingSettings.appearance.background[0].tileImage = customisationData?.bgTileImage ?? settingsObject?.appearance.background[0].tileImage ?? false;
        resultingSettings.appearance.background[0].filename = customisationData?.bgFilename ?? settingsObject?.appearance.background[0].filename ?? {
            "filename": "barTile.png",
            "isDefault": true,
            "srcUrl": "./img/barTile.png",
            "originalFile": "barTile.png",
                "type": "image"
            };
        resultingSettings.appearance.background[0].animateImage = customisationData?.bgAnimateImage ?? settingsObject?.appearance.background[0].animateImage ?? false;
        resultingSettings.appearance.background[0].reverseImageAnim = customisationData?.bgReverseImageAnim ?? settingsObject?.appearance.background[0].reverseImageAnim ?? false;

        return resultingSettings;
    }
    return CustomSettings['inlineprogressbar'];
}

export const convertCustomisationDataArrayToBarSettings = (settingsArray) => {
    let settingsObject = null;
    for (let i = 0; i < settingsArray.length; i++) {
        const resultingSettings = convertCustomisationDataToBarSettings(settingsArray[i], settingsObject);
        if (resultingSettings) {
            settingsObject = resultingSettings;
            break;
        }
    }
    return settingsObject;
}

export default class InlineProgressBar extends Component {
    constructor(props) {
        super(props);

        this.state = {
            // barVisible: true,
            // fillPerc: typeof this.props.startPerc !== 'undefined' ? this.props.startPerc : 1,
            // overlayImages: [],
            // quiz: this.props.quiz,
            // forceUpdate: false,
        }
    }

    // make sure you call the superclass in didMount and willUnmount
    componentDidMount() {
        // I would recommend doing your stuff before calling super.componentDidMount,
        // as this may cause a callback...
        // super.componentDidMount();

        /* activeBars[this.props.viewId] = this;
        if (barOverlayImages[this.props.viewId]) {
            this.overlayImagesUpdated();
        } */
    }

    componentWillUnmount() {
        // the super version of this removes a resize listener so, make sure you call this!
        // super.componentWillUnmount();

        // activeBars[this.props.viewId] = null;
    }

    overlayImagesUpdated() {
        /* if (barOverlayImages[this.props.viewId]) {
            const overlayImages = [];
                for (let i = 0; i < barOverlayImages[this.props.viewId].length; i++) {
                    overlayImages.push({...barOverlayImages[this.props.viewId][i]});
                }
            this.setState({overlayImages: overlayImages});
        } */
    }

    render() {
        // console.log("InlineProgressBar render, props = ", this.props);
        // console.log("progressbar render, viewId = ",this.props.viewId);
        // console.log("CustomSettings = ", CustomSettings[this.props.viewId]);

        // const pos = SettingOverrides[this.props.viewId] && SettingOverrides[this.props.viewId].position ? SettingOverrides[this.props.viewId].position : CustomSettings[this.props.viewId].shapeAndPosition && CustomSettings[this.props.viewId].shapeAndPosition.position ? CustomSettings[this.props.viewId].shapeAndPosition.position[0].position : 'bottom-above-answers';
        let dir = 'horizontal'; // this.props.dir || 'horizontal'; // pos === 'top' || pos === 'bottom' || pos === 'bottom-above-answers' || pos === "bottom-above-image-answers" || pos === "bottom-above-answers-overlapped" || pos === "bottom-above-image-answers-overlapped" || pos === "bottom-answers-sides" || pos === "bottom-image-answers-sides"  ? 'horizontal' : 'vertical';

        // const barLength = SettingOverrides[this.props.viewId] && SettingOverrides[this.props.viewId].length ? SettingOverrides[this.props.viewId].length : null;
        /* let width = barLength ||
            (CustomSettings[this.props.viewId].shapeAndPosition && CustomSettings[this.props.viewId].shapeAndPosition.shape ? CustomSettings[this.props.viewId].shapeAndPosition.shape[0].length : 90 / 100) *
            (dir === 'horizontal' ? 1920 : 1080); */
        

        /* if(pos === "bottom-above-answers" || pos === "bottom-above-image-answers" || pos === "bottom-above-answers-overlapped" || pos === "bottom-above-image-answers-overlapped") {
            // width *= 1.7;
            width = 1150;
        } else
        if (pos === "bottom-answers-sides" || pos === "bottom-image-answers-sides") {
            width = 680;
        }
        console.log('Progress Bar pos: ', pos); */

        // console.log("filledWidth = ", width * this.state.fillPerc);
        let width = this.props.width || 540;
        let height = this.props.height || 70;

        let marginTop = 0; // pos === 'bottom' ? 150 : (pos === 'left' || pos === 'right') ? width / 2 : 0;
        let marginLeft = 0; // (pos === 'top' || pos === 'bottom' || dir === 'horizontal') ? -width / 2 : pos === 'right' ? -70 : 0;
        let offsetX = 0; // CustomSettings[this.props.viewId].shapeAndPosition && CustomSettings[this.props.viewId].shapeAndPosition.position ? CustomSettings[this.props.viewId].shapeAndPosition.position[0].offsetX : 0;
        let offsetY = 0; // CustomSettings[this.props.viewId].shapeAndPosition && CustomSettings[this.props.viewId].shapeAndPosition.position ? CustomSettings[this.props.viewId].shapeAndPosition.position[0].offsetY : 0;

        /* let height = CustomSettings[this.props.viewId].shapeAndPosition && CustomSettings[this.props.viewId].shapeAndPosition.shape ? CustomSettings[this.props.viewId].shapeAndPosition.shape[0].thickness : 30; */

        // Hard code values for quizzes!
        // Make sure to call SetProgressBarCustomisation() to reset the position for Polls / Tug of War,
        // as our quiz uses SetProgressBarPositionString() to change the hard code the position specifically for quiz layouts.
        /* switch (pos) {
            case 'bottom-above-answers':
            case 'bottom-above-image-answers':
                width = 1150;
                height = 30;
                marginTop = 0;
                marginLeft = -width / 2;
                offsetX = 0;
                offsetY = 0;
                break;
            case 'bottom-above-answers-overlapped':
            case 'bottom-above-image-answers-overlapped':
                width = 1150;
                height = 30;
                marginTop = 0;
                marginLeft = -width / 2;
                offsetX = 0;
                offsetY = 30;
                break;
            case 'bottom-answers-sides':
            case 'bottom-image-answers-sides':
                width = barLength ? barLength : 680;
                height = 30;
                marginTop = 0;
                marginLeft = -width / 2;
                offsetX = 0;
                offsetY = 10;
                break;
            case 'bottom':
            default:
                width = 1150;
                height = 30;
                marginTop = 0;
                marginLeft = -width / 2;
                offsetX = 0;
                offsetY = 0;
                break;
        } */

        const customSettings = this.props.customSettings ? {...this.props.customSettings} : CustomSettings['inlineprogressbar'];

        // We have an alternative format for progress bars which needs converting.
        if (typeof customSettings.shapeAndPosition === 'undefined' && customSettings.shape) {
            customSettings.shapeAndPosition = {
                ...this.props.customSettings
            }
        }
        if (typeof customSettings.appearance === 'undefined' && customSettings.fill) {
            customSettings.appearance = {
                ...this.props.customSettings
            }
        }

        // console.log("InlineProgressBar render, customSettings = ", customSettings);

        const shape = this.props.shape ?? customSettings.shapeAndPosition.shape[0].shape;
        const cornerRadiusDivider = this.props.cornerRadiusDivider ?? 2;
        const cornerRadius = shape === 'rounded' ? (customSettings.shapeAndPosition.shape[0].roundness / 100 * height) / cornerRadiusDivider : 0;
        let strokeWidth = this.props.useOutline ? customSettings.appearance.outline[0].thickness * (this.props.previewScale ?? 1) : 0;
        if (strokeWidth > 0 && strokeWidth < 1) {
            strokeWidth = 1;
        }
        const strokeColour = COLOUR_NAME_TO_COLOUR_HEX(customSettings.appearance.outline[0].colour, WORKING_ON_NODE_DATA.campaignData);
        const skew = shape === 'angled' ? customSettings.shapeAndPosition.shape[0].skew : 0;

        const bgStyle = customSettings.appearance.background[0].fillType;
        const bgStripeDir = customSettings.appearance.background[0].stripeDirection;
        const bgStripeColour1 = COLOUR_NAME_TO_COLOUR_HEX(customSettings.appearance.background[0].stripeColour1, WORKING_ON_NODE_DATA.campaignData);
        const bgStripeColour2 = COLOUR_NAME_TO_COLOUR_HEX(customSettings.appearance.background[0].stripeColour2, WORKING_ON_NODE_DATA.campaignData);
        const bgAnimateStripes = customSettings.appearance.background[0].animateStripes;
        const reverseBgStripeAnim = customSettings.appearance.background[0].reverseStripeAnim;
        const solidBgColour = COLOUR_NAME_TO_COLOUR_HEX(customSettings.appearance.background[0].solidColour, WORKING_ON_NODE_DATA.campaignData);

        const bgImage = customSettings.appearance.background[0].filename.srcUrl;
        const tileBgImage = customSettings.appearance.background[0].tileImage;
        const animateBgImage = customSettings.appearance.background[0].animateImage;
        const reverseBgImageAnim = customSettings.appearance.background[0].reverseImageAnim;

        const fillStyle = customSettings.appearance.fill[0].fillType;
        const fillStripeDir = customSettings.appearance.fill[0].stripeDirection;
        const fillStripeColour1 = COLOUR_NAME_TO_COLOUR_HEX(customSettings.appearance.fill[0].stripeColour1, WORKING_ON_NODE_DATA.campaignData);
        const fillStripeColour2 = COLOUR_NAME_TO_COLOUR_HEX(customSettings.appearance.fill[0].stripeColour2, WORKING_ON_NODE_DATA.campaignData);
        const fillAnimateStripes = customSettings.appearance.fill[0].animateStripes;
        const reverseFillStripeAnim = customSettings.appearance.fill[0].reverseStripeAnim;
        const solidFillColour = COLOUR_NAME_TO_COLOUR_HEX(customSettings.appearance.fill[0].solidColour, WORKING_ON_NODE_DATA.campaignData);

        const fillHeight = cornerRadius <= 0 || shape !== 'rounded' || width * this.props.fillPerc > cornerRadius ? height : height * ((width * this.props.fillPerc) / cornerRadius);
        const fillOffsetY = shape === 'rounded' && fillHeight !== height ? (height - fillHeight) / 2 : 0;

        const fillImage = customSettings.appearance.fill[0].filename.srcUrl;
        const tileFillImage = customSettings.appearance.fill[0].tileImage;
        const animateFillImage = customSettings.appearance.fill[0].animateImage;
        const reverseFillImageAnim = customSettings.appearance.fill[0].reverseImageAnim;
        const fillImageEdgeBuffer = customSettings.appearance.fill[0].imageEdgeBuffer;

        const barViewId = this.props.viewId || 'inlineprogressbar';

        const stripeWidth = (this.props.stripeWidth || 30) * (this.props.previewScale ?? 1);
        const scaledSkew = skew * (this.props.previewScale ?? 1);

        return (
            <div id={barViewId} style={{ width: '100%', height: '100%', "--stripeAnimTime": (1 * 1 / (this.props.previewScale ?? 1)) + 's' }}>
                <div className={`pb__progress-bar pb__${dir}`} style={{ width: '100%', height: '100%' }}>
                    <div className='pb__progress-bar-part' style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? offsetX : -offsetY }}>
                        {shape === 'angled' ? GetSvgAngledRect(width, height, 0, '#000000', solidBgColour, scaledSkew, bgStyle === 'solid' ? '' : 'bg-mask-' + barViewId) : GetSvgRect(width, height, 0, '#000000', solidBgColour, cornerRadius, bgStyle === 'solid' ? '' : 'bg-mask-' + barViewId)}
                    </div>

                    {bgStyle === 'striped' &&
                        <div className={`pb__progress-bar-part${bgAnimateStripes ? (bgStripeDir === 'diagonal' ? ' pb__diagonal-stripe-anim' : ' pb__vertical-stripe-anim') + (reverseBgStripeAnim ? '-rev' : '') : ''}`} style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? offsetX - scaledSkew / 2 : -offsetY - scaledSkew / 2, width: width + scaledSkew, height: height, backgroundImage: (bgStripeDir === 'diagonal' ? GetDiagonalStripes(bgStripeColour1, bgStripeColour2, stripeWidth) : GetVerticalStripes(bgStripeColour1, bgStripeColour2, stripeWidth)), clipPath: `url(#bg-mask-${barViewId})` }}>
                        </div>
                    }

                    {bgStyle === 'image' && tileBgImage &&
                        <div className={`pb__progress-bar-part pb__tiled-bg-image${animateBgImage ? ' pb__tiled-bg-image-anim' + (reverseBgImageAnim ? '-rev' : '') : ''}`} style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? offsetX - scaledSkew / 2 : -offsetY - scaledSkew / 2, width: width + scaledSkew, height: height, backgroundImage: `url(${bgImage})`, clipPath: `url(#bg-mask-${barViewId})` }}>
                        </div>
                    }

                    {bgStyle === 'image' && !tileBgImage &&
                        <div className={`pb__progress-bar-part pb__bg-image`} style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? offsetX - scaledSkew / 2 : -offsetY - scaledSkew / 2, width: width + scaledSkew, height: height, backgroundImage: `url(${bgImage})`, clipPath: 'url(#bg-mask)' }}>
                        </div>
                    }

                    <div className='pb__progress-bar-part' style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? offsetX : -offsetY, clipPath: `url(#bg-mask-${barViewId})` }}>
                        {shape === 'angled' ? GetSvgAngledRect(width * this.props.fillPerc, height, 0, '#FFFFFF', solidFillColour, scaledSkew, fillStyle === 'solid' ? '' : 'fill-mask-' + barViewId) : GetSvgRect(width * this.props.fillPerc, fillHeight, 0, '#FFFFFF', solidFillColour, cornerRadius, fillStyle === 'solid' ? '' : 'fill-mask-' + barViewId, fillOffsetY)}
                    </div>

                    {fillStyle === 'striped' &&
                        <div className={`pb__progress-bar-part${fillAnimateStripes ? (fillStripeDir === 'diagonal' ? ' pb__diagonal-stripe-anim' : ' pb__vertical-stripe-anim') + (reverseFillStripeAnim ? '-rev' : '') : ''}`} style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? offsetX - scaledSkew / 2 : -offsetY - scaledSkew / 2, width: width + scaledSkew, height: height, backgroundImage: (fillStripeDir === 'diagonal' ? GetDiagonalStripes(fillStripeColour1, fillStripeColour2, stripeWidth) : GetVerticalStripes(fillStripeColour1, fillStripeColour2, stripeWidth)), clipPath: `url(#fill-mask-${barViewId})` }}>
                        </div>
                    }

                    {fillStyle === 'image' && tileFillImage &&
                        <div className={`pb__progress-bar-part pb__tiled-bg-image${animateFillImage ? ' pb__tiled-bg-image-anim' + (reverseFillImageAnim ? '-rev' : '') : ''}`} style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? offsetX - scaledSkew / 2 : -offsetY - scaledSkew / 2, width: width + scaledSkew, height: height, backgroundImage: `url(${fillImage})`, clipPath: `url(#fill-mask-${barViewId})` }}>
                        </div>
                    }

                    {fillStyle === 'image' && tileFillImage === false &&
                        <>
                            <div className='pb__progress-bar-part' style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? offsetX : -offsetY }}>
                                {shape === 'angled' ? GetSvgAngledRect(width, height, 0, '#000000', solidBgColour, scaledSkew, 'img-mask-' + barViewId) : GetSvgRect(width, height, 0, '#000000', solidBgColour, cornerRadius, 'img-mask-' + barViewId)}
                            </div>
                            <div className={`pb__progress-bar-part pb__bg-image`} style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? (offsetX - scaledSkew / 2) : (-offsetY - scaledSkew / 2), width: width + scaledSkew, height: height, backgroundImage: `url(${fillImage})`, clipPath: `url(#img-mask-${barViewId})`, backgroundSize: `${width + scaledSkew + fillImageEdgeBuffer}px auto`, backgroundPositionX:  -((1 - this.props.fillPerc) * (width + scaledSkew)) }}>
                            </div>
                        </>
                    }

                    <div className='pb__progress-bar-part' style={{ marginTop: dir === 'vertical' ? offsetX : offsetY, marginLeft: dir === 'horizontal' ? offsetX : -offsetY }}>
                        {shape === 'angled' ? GetSvgAngledRect(width, height, strokeWidth, strokeColour, 'none', scaledSkew) : GetSvgRect(width, height, strokeWidth, strokeColour, 'none', cornerRadius)}
                    </div>

                </div>
            </div>
        )
    }
}

InlineProgressBar.defaultProps = {
    useOutline: true,
}
